import { createBrowserRouter } from 'react-router-dom';
import { LoginLayoutRoute, ProtectedLayoutRoute } from '@/layout';
import App from '@/App';
import routes from '@/app/routes';
import LandingPage from '@/pages/home';
import MatchMakerPage from '@/pages/match-maker';
import MatchMakerOutputMaterialListPage from '@/pages/match-maker/output-materials';
import MatchMakerProductionConsumptionListPage from '@/pages/match-maker/production-and-cosumption';
import SoftTagSelectionPage from '@/pages/match-maker/soft-tag-selection';
import MatchMakerMaterialStockReconciliationListPage from '@/pages/match-maker/material-stock-reconciliation';
import ProductionReporting from '@/pages/production-reporting';
import StockReconciliation from '@/pages/stock-reconciliation';
import ErrorPage from '@/pages/error';
import AddProductionReportingListPage from '@/features/production-reporting/production-period/add-production-reporting-list';
import ReviewReportProductionReportingPage from '@/features/production-reporting/production-period/report-review';

const toRelativePath = (path: string) => path.replace(/^\//, '');

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: toRelativePath(routes.LOGIN),
        element: <LoginLayoutRoute />,
      },
      {
        element: <ProtectedLayoutRoute />,
        children: [
          {
            index: true,
            element: <LandingPage />,
          },
          {
            path: toRelativePath(routes.MATCH_MAKER),
            element: <MatchMakerPage />,
          },
          {
            path: toRelativePath(routes.MATCH_MAKER_OUTPUT_MATERIALS),
            element: <MatchMakerOutputMaterialListPage />,
          },
          {
            path: toRelativePath(routes.MATCH_MAKER_PRODUCTION_CONSUMPTION),
            element: <MatchMakerProductionConsumptionListPage />,
          },
          {
            path: toRelativePath(routes.MATCH_MAKER_MATCH_WITH_SOFTTAG),
            element: <SoftTagSelectionPage />,
          },
          {
            path: toRelativePath(
              routes.MATCH_MAKER_MATERIAL_STOCK_RECONCILIATION
            ),
            element: <MatchMakerMaterialStockReconciliationListPage />,
          },
          {
            path: toRelativePath(routes.PRODUCTION_REPORTING),
            element: <ProductionReporting />,
          },
          {
            path: toRelativePath(routes.PRODUCTION_REPORTING_ADD_PERIODS),
            element: <AddProductionReportingListPage />,
          },
          {
            path: toRelativePath(routes.PRODUCTION_REPORTING_REVIEW_PERIODS),
            element: <ReviewReportProductionReportingPage />,
          },
          {
            path: toRelativePath(routes.STOCK_RECONCILIATION),
            element: <StockReconciliation />,
          },
          {
            path: '*',
            element: <ErrorPage errorStatusCode={404} />,
          },
        ],
      },
    ],
  },
]);
